// Does a free-text search term read as one specific UK registration?
//
// Used by the search boxes to offer "go to this plate's page" alongside the
// normal broad search, so typing XJ220 can mean either the plate XJ 220 or
// "plates like XJ220" without the box guessing. Shape-only check (the plate
// page itself covers every registration, issued or not).

import { normaliseRegistration } from './canonical-url';

const FORMATS: RegExp[] = [
  /^([A-Z]{2}[0-9]{2})([A-Z]{3})$/, // current   AB12 CDE
  /^([A-Z][0-9]{1,3})([A-Z]{3})$/, // prefix    A123 BCD
  /^([A-Z]{3})([0-9]{1,3}[A-Z])$/, // suffix    ABC 123D
  /^([A-Z]{1,3})([0-9]{1,4})$/, // dateless  ABC 1234 (incl. NI)
  /^([0-9]{1,4})([A-Z]{1,3})$/, // dateless  1234 ABC
];

/** The registration as written ("XJ 220"), or null if the term isn't one. */
export function matchRegistration(term: string): string | null {
  const reg = normaliseRegistration(term);
  if (reg.length < 2 || reg.length > 7) return null;
  for (const f of FORMATS) {
    const m = reg.match(f);
    if (m) return `${m[1]} ${m[2]}`;
  }
  return null;
}
